// extracted by extract-css-chunks-webpack-plugin
module.exports = {"phtvPeopleBox":"phtvPeopleBox-1u_l-Xn1","phtvPeopleLink":"phtvPeopleLink-2uoy1w5J","phtvPeopleLastLink":"phtvPeopleLastLink-2IsQGUMu"};